import Barba from "barba.js";
import Channels from "../base/channels.js";
import TransitionDispatcher from "../transition/TransitionDispatcher";
import TransitionPopin from "../transition/TransitionPopin";
import Env from "../base/env";

class OuterHeaven {
  constructor() {
    Barba.Pjax.preventCheck = function () {
      return false;
    };

    Barba.Pjax.cacheEnabled = true;
    Barba.Utils.xhrTimeout = 10000;
    Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
    Barba.Pjax.preventCheck = function (evt, element) {
      var href = this.getHref(element);

      //User
      if (!element || !href) return false;

      //Middle click, cmd click, and ctrl click
      if (
        evt.which > 1 ||
        evt.metaKey ||
        evt.ctrlKey ||
        evt.shiftKey ||
        evt.altKey
      )
        return false;

      if (element.getAttribute("href") != null && href.indexOf("#") > -1)
        return false;
      // if (Env.allowHashlinksInBarba == true) {
      //   return true;
      // } else {
      //   return false;
      // }
      else {
        return Barba.Pjax.originalPreventCheck(evt, element);
      }
    };
    Barba.Prefetch.init();
    Barba.Pjax.getTransition = function () {
      let transition =
        Env.framework.popin.ENABLED === true
          ? TransitionPopin
          : TransitionDispatcher;
      return transition;
    };
    Barba.Pjax.start();
    Barba.Dispatcher.on("linkClicked", function () {});
    Barba.Dispatcher.on("initStateChange", () => {
      Channels.emit("statechange::before");
    });
    Barba.Dispatcher.on("newPageReady", function (current, old, container) {
      Channels.emit("statechange::ready", current, old, container);
    });
  }
}

export default OuterHeaven;
